import { create } from "zustand";
import { SpecType } from "../API/types/municipalities.types";

interface SidebarFormState {
  customState: string;
  setCustomState: (value: string) => void;
  customMunicipality: string;
  setCustomMunicipality: (value: string) => void;
  websiteUrl: string;
  setWebsiteUrl: (value: string) => void;
  specType: SpecType;
  setSpecType: (value: SpecType) => void;
  specFilters: string[];
  setSpecFilters: (value: string[]) => void;
  showCustomStateInput: boolean;
  setShowCustomStateInput: (value: boolean) => void;
  showCustomMunicipalityInput: boolean;
  setShowCustomMunicipalityInput: (value: boolean) => void;
}

export const useSidebarFormStore = create<SidebarFormState>((set) => ({
  customState: "",
  setCustomState: (value) => set({ customState: value }),
  customMunicipality: "",
  setCustomMunicipality: (value) => set({ customMunicipality: value }),
  websiteUrl: "",
  setWebsiteUrl: (value) => set({ websiteUrl: value }),
  specType: "DirectFile",
  setSpecType: (value) => set({ specType: value }),
  specFilters: [],
  setSpecFilters: (value) => set({ specFilters: value }),
  showCustomStateInput: false,
  setShowCustomStateInput: (value) => set({ showCustomStateInput: value }),
  showCustomMunicipalityInput: false,
  setShowCustomMunicipalityInput: (value) =>
    set({ showCustomMunicipalityInput: value }),
}));
